export default __webpack_public_path__ + "ad0df098a992698bf10b7b9745e1cf0f.png";